import styled from 'styled-components';
import BaseHopCardIcon from '#/shared/components/GeneratedIcons/trimet/HopReversed';
import CopyTripIcon from '#/shared/components/GeneratedIcons/generic/ContentCopy';
import FeedbackIcon from '#/shared/components/GeneratedIcons/trimet/Feedback';
import PrintTripIcon from '#/shared/components/GeneratedIcons/generic/Printer';
import EditTripIcon from '#/shared/components/GeneratedIcons/trimet/TripPlannerSolid';
import { DESKTOP_MIN_BREAK, GTM_DATA_ATTRIBUTE } from '#/shared/constants';
import { InverseClearButton } from '#/shared/components/Styled';

export const TripHopCardFooterWrapper = styled.div`
  /* needs to be a flexbox row */
  max-width: ${DESKTOP_MIN_BREAK};
  background-color: ${props => props.theme.mainColor};
  color: ${props => props.theme.secondaryBackgroundColor};
  display: block;
  padding-top: 15px;
  flex: 1;
`;

export const TripHopCardTopRow = styled.div`
  max-width: ${DESKTOP_MIN_BREAK};
  display: flex;
  flex-flow: row;
  justify-content: center;
  margin: 4px 12px;
`;

export const HopCardIconColumn = styled.div`
  position: relative;
  flex: 1 1 85px;
  min-height: 55px;
`;

export const HopCardHeaderTextColumn = styled.div`
  padding: 5px;
  text-align: left;
  flex: 1 1 auto;
`;

export const HopCardHeaderText = styled.div`
  position: relative;
  font-size: 1.2em;
`;

export const HopCardHeaderSubText = styled.div`
  font-size: 0.8em;
`;

export const HopCardIcon = styled(BaseHopCardIcon).attrs({
  width: '90%',
  height: '90%',
})`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-40%, -50%);
`;

export const HopCardTripActionRow = styled.div`
  max-width: ${DESKTOP_MIN_BREAK};
  display: flex;
  flex-flow: row;
  margin: 0px 8px;
`;

export const HopCardTripFooterRow = styled.div`
  max-width: ${DESKTOP_MIN_BREAK};
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: center;
  padding: 10px;
  font-size: 0.8em;
`;

export const HopCardTripActionColumn = styled.div`
  flex: 1 1 0;
  margin: 4px;
`;
export const TripActionIconColumn = styled.div`
  position: relative;
  flex: 0 0 40px;
  min-height: 30px;
`;
export const PrintTripActionIcon = styled(PrintTripIcon).attrs(props => ({
  width: '90%',
  height: '90%',
  fill: props.theme.secondaryBackgroundColor,
}))`
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
`;

export const EditTripActionIcon = styled(EditTripIcon).attrs(props => ({
  width: '90%',
  height: '90%',
  fill: props.theme.secondaryBackgroundColor,
}))`
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
`;

export const SendFeedbackActionIcon = styled(FeedbackIcon).attrs(props => ({
  width: '90%',
  height: '90%',
  fill: props.theme.secondaryBackgroundColor,
}))`
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
`;

export const CopyTripActionIcon = styled(CopyTripIcon).attrs(props => ({
  width: '90%',
  height: '90%',
  fill: props.theme.secondaryBackgroundColor,
}))`
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
`;

export const HopCardTripActionButton = styled(InverseClearButton).attrs(
  props => ({
    [GTM_DATA_ATTRIBUTE]: props.dataGtm,
  })
)`
  position: relative;
  display: flex;
  align-items: center;
  flex-flow: row;
  background-color: ${props => props.theme.actionColor};
  width: 100%;
  font-size: 1em;
  padding: 10px 0px;
  border: 1px solid ${props => props.theme.actionColor};
  border-radius: 5px;
  text-align: center;
  justify-content: center;
  @media (any-hover: hover) {
    &:hover {
      background-color: ${props => props.theme.inverseButtonColor2};
    }
  }
  &:focus,
  &:active {
    background-color: ${props => props.theme.actionColor};
  }
`;

export const SiteLink = styled(InverseClearButton).attrs({
  role: 'link',
})`
  padding: 5px;
  opacity: ${props => props.theme.inactiveOpacity};
  @media (any-hover: hover) {
    &:hover {
      opacity: 1;
      background-color: transparent;
    }
  }
  &:focus,
  &:active {
    background-color: transparent;
  }
`;
